module.exports = __webpack_public_path__ + "static/img/26.8bc324a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/26.jpg
// module id = rowm
// module chunks = 16